import { KeyValueList, type KeyValueListProps } from '@nexvia-logistics/ui';

export type { KeyValueListProps };

/*
 * Storage responsive pass (2026-10-27): a patch until @nexvia-logistics/ui stacks its own `KeyValueList`
 * on phones. The package gives the term a fixed 150px column, which leaves the value ~74px on a 320px
 * phone; these classes stack term over value and let a long value (an email, a RUT) break. They win
 * over the package's utilities by specificity (`.x dt` beats `.w-[150px]`), not by order.
 */
const ALWAYS = '[&_dd]:min-w-0 [&_dd]:wrap-anywhere';
const STACK_MOBILE =
  'max-md:[&>div]:flex-col max-md:[&>div]:items-stretch max-md:[&>div]:gap-0.5 max-md:[&_dt]:w-auto';
const STACK_ALWAYS = '[&>div]:flex-col [&>div]:items-stretch [&>div]:gap-0.5 [&_dt]:w-auto';

/** `stack="always"` is for lists in a narrow column at every size (QuoteForm's 320px aside). */
export function KeyValueListStacked({
  stack = 'mobile',
  className,
  ...props
}: KeyValueListProps & { stack?: 'mobile' | 'always' }) {
  const stackClasses = stack === 'always' ? STACK_ALWAYS : STACK_MOBILE;
  return <KeyValueList {...props} className={[className, ALWAYS, stackClasses].filter(Boolean).join(' ')} />;
}
